import { useLocation } from "@tanstack/react-router"
import { NotFoundLogo } from "@ui/components/not-found/NotFoundLogo"

import { DotGridBackground } from "@/routes/-components/site/DotGridBackground"
import { SiteSection } from "@/routes/-components/site/SiteSection"

export function NotFoundPage() {
  const location = useLocation()
  const loginHref = `/login?${new URLSearchParams({ next: location.href }).toString()}`

  return (
    <SiteSection
      outerClassName="flex grow flex-col"
      innerClassName="relative flex min-h-[440px] flex-1 items-center justify-center overflow-hidden px-6 py-16 sm:min-h-[520px] sm:px-8"
    >
      <DotGridBackground className="pointer-events-none absolute inset-0 size-full" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 size-full"
        style={{
          backgroundImage:
            "linear-gradient(to bottom, var(--surface-base) 0%, color-mix(in srgb, var(--surface-base) 20%, transparent) 100%)",
        }}
      />
      <div
        className="relative flex w-full max-w-140 flex-col items-center text-center"
        aria-labelledby="not-found-heading"
      >
        <NotFoundLogo />
        <h1 id="not-found-heading" className="mt-5 font-mono text-4xl font-bold text-default">
          404
        </h1>
        <p className="text-site-body-sm mt-4 max-w-110 font-sans text-muted">
          The page you're looking for doesn't exist, has been moved, or you may need to{" "}
          <a
            href={loginHref}
            className="text-default underline underline-offset-2 hover:no-underline"
          >
            log in
          </a>{" "}
          to view it.
        </p>
      </div>
    </SiteSection>
  )
}
